import { useTranslation } from 'react-i18next';
import { UserRole } from '~/graphql/graphql';

export function useUserRoleLabels(): Record<UserRole, string> {
  const { t } = useTranslation('users');
  return {
    [UserRole.PlatformAdmin]: t('users.role.platformAdmin'),
    [UserRole.TenantAdmin]: t('users.role.admin'),
    [UserRole.Buyer]: t('users.role.buyer'),
    [UserRole.Seller]: t('users.role.seller'),
    [UserRole.Trader]: t('users.role.trader'),
  };
}
